import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { ProfessionnelItem } from '../model/professionnel-item';
import { ConfirmerProfessionnelItem } from '../model/confirmer-credit';
import { FaciliteProfessionnelDTO } from '../model/facilite-professionnel-dto';

@Injectable({
    providedIn: 'root'
  })
  export class ProfessionnelItemService{

    constructor(private _restClientService : RestClientService) 
    {}

    getListProfessionnelItemByRequest(requestId){
        return this._restClientService.load<ProfessionnelItem[]>('professionnel-item/professionnel-item-by-request?requestId='+requestId);
    }

    getProfessionnelItemById(id) {
        return this._restClientService.load<ProfessionnelItem>('professionnel-item/professionnel-item-by-id/'+id);
    }
  
    putProfessionnelItem(professionnelItem: ProfessionnelItem) {
        return this._restClientService.put<void>('professionnel-item/update-professionnel-item', professionnelItem);
    }
  
    confirmer(confirmerProfessionnelItem: ConfirmerProfessionnelItem) {
        return this._restClientService.put<void>('professionnel-item/confirmer-credit', confirmerProfessionnelItem);
    }
    
    findFacilitesProfessionnel(requestId){
        return this._restClientService.load<FaciliteProfessionnelDTO[]>('professionnel-item/facilite-professionnel-by-request?requestId='+requestId);
    }
  
}